document.addEventListener('DOMContentLoaded', () => {
  console.log('Termaggedon');
  const waitForElement = async (selector) => {
    return new Promise((resolve, reject) => {
      const observer  = new MutationObserver(() => {
        const element = document.querySelector(selector);
        if (element) {
          observer.disconnect();
          resolve(element);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }

  const buildTOC = () => {
    const content = document.querySelector(".policy_embed_div article");
    const fallbackContent = document.querySelector(".text-rich-text");
    const finalContent = content || fallbackContent;

    let tocRoot = document.querySelector(".blog-post_content_link-content");
    if (!tocRoot && finalContent && finalContent.parentElement) {
      tocRoot = document.createElement("nav");
      tocRoot.className = "blog-post_content_link-content";
      finalContent.parentElement.insertBefore(tocRoot, finalContent);
    }

    if (!finalContent || !tocRoot) {
      console.warn("TOC: content or tocRoot not found.");
      return;
    }

    const candidates = finalContent.querySelectorAll("h2, h3, h4, h5, h6, .accordion-heading");
    const headings = Array.from(candidates).filter((el) => {
      const inAccordions = !!el.closest(".accordions");
      if (inAccordions) return el.classList.contains("accordion-heading");
      return true;
    });

    if (!headings.length) return;

    let stack = [{ level: 1, element: tocRoot }];
    const tocLinks = [];

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = "heading-" + index;
      const level = parseInt(heading.tagName.slice(1), 10) || 3;

      const wrapper = document.createElement("div");
      wrapper.classList.add("blog-post_content_link-wrapper", `is-h${level}`);

      const link = document.createElement("a");
      link.href = "#" + heading.id;
      link.classList.add("blog-post_content_link", `is-h${level}`, "w-inline-block");

      const inner = document.createElement("div");
      inner.setAttribute("fs-toc-element", "link");
      inner.textContent = heading.textContent.trim();

      link.appendChild(inner);
      wrapper.appendChild(link);

      while (stack.length && stack[stack.length - 1].level >= level) {
        stack.pop();
      }
      stack[stack.length - 1].element.appendChild(wrapper);
      stack.push({ level, element: wrapper });

      link.addEventListener("click", (e) => {
        e.preventDefault();
        let p = heading.parentElement;
        while (p) {
          if (p.tagName === "DETAILS") p.open = true;
          p = p.parentElement;
        }

        // switch .current to the clicked link
        tocLinks.forEach((i) => i.link.classList.remove("current"));
        link.classList.add("current");

        const offset = 120;
        const top = heading.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: "smooth" });
        history.replaceState(null, "", "#" + heading.id);
      });

      tocLinks.push({ link, heading });
    });

    function onScroll() {
      const scrollPos = window.scrollY + 120;
      let current = null;

      headings.forEach((h) => {
        const top = h.getBoundingClientRect().top + window.scrollY;
        if (top <= scrollPos) current = h;
      });

      tocLinks.forEach((i) => i.link.classList.remove("current"));
      if (current) {
        const active = tocLinks.find((i) => i.heading === current);
        if (active) active.link.classList.add("current");
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  const init = async () => {
    await waitForElement('.tpt-section-heading'); // Pause init() until waitForElement() returns the Promise
    buildTOC();
  }

  init();
});